const environmentLabels: Record<string, string> = {
  PROD_EU: "Prod EU",
  PROD_US: "Prod US",
  STAGING: "Staging",
  I12E: "I12E",
  GHA_EU: "GHA EU",
  TEST: "Test",
  LOCAL: "Local",
  CI: "CI",
};

/** Formats known environment identifiers; preserves unknown names. */
export const formatEnvironment = (environment: string): string => environmentLabels[environment.toUpperCase().replaceAll("-", "_")] ?? environment;
